var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.00001C5 4.14339 4.93998 4.28675 4.82018 4.39606L1.0486 7.83589C0.808678 8.0547 0.419689 8.0547 0.179867 7.83589C-0.0599556 7.61716 -0.0599556 7.26245 0.179867 7.04362L3.51717 4.00001L0.179983 0.956392C-0.0598391 0.737575 -0.0598391 0.382905 0.179983 0.164193C0.419806 -0.0547314 0.808794 -0.0547314 1.04871 0.164193L4.8203 3.60397C4.94011 3.71333 5 3.85669 5 4.00001Z",
    fill: "#4F9DDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.68b2befcb48963353961fc8c5c7118b2.svg";
export { ForwardRef as ReactComponent };